export const CHANGE_END_DATE = 'datepicker-range:end';
export const CHANGE_START_DATE = 'datepicker-range:start';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/datepicker-range/action-types.js
 **/